function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "current",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Comp-/-left-menu-Doctor",
  transform: "translate(-16.000000, -185.000000)",
  fill: "current",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: 4,
  transform: "translate(16.000000, 183.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.30141234,14.0159578 C1.33499099,11.1432573 2.53112989,8.40618858 4.61782663,6.42716208 C6.70452337,4.44813558 9.50442258,3.39535539 12.3808262,3.5082241 C18.1958794,3.78370984 22.741146,8.61743098 22.6477332,14.4266958 C22.5193967,20.2987426 17.6534368,24.9594799 11.769372,24.8462603 C5.88530719,24.7330407 1.20297408,19.8885778 1.30152763,14.0159578 L1.30141234,14.0159578 Z M10.0817211,16.4502374 C8.81609209,15.5369942 7.96599798,14.3875148 6.84062926,13.5017156 C6.4591073,13.8536533 6.11747854,14.1596787 5.7874949,14.4777288 C5.65276888,14.6075263 5.54323552,14.7633294 5.38971588,14.9461161 C6.06336378,15.736178 6.7857463,16.4835246 7.5526537,17.1838007 C8.29123095,18.0372791 9.12088505,18.8078102 10.0268968,19.4817238 C10.2863179,19.2642439 10.5323644,19.0847366 10.7465886,18.873758 C11.5652063,18.067011 12.3686622,17.2455351 13.1858387,16.4376949 C14.659927,14.9805217 16.1539043,13.5429102 17.6059707,12.0643342 C17.9143935,11.750254 18.3516622,11.4947438 18.4308144,10.9638741 L17.1079398,9.62568199 C15.86058,10.6647671 14.6873596,11.7894165 13.5968194,12.9914431 C12.4314998,14.0996704 11.3023839,15.2458702 10.0817211,16.4502374 L10.0817211,16.4502374 Z",
  id: "Shape"
}))));

function SvgIconLeftmenuDoctor04(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_leftmenu_doctor04") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeftmenuDoctor04);
export default __webpack_public_path__ + "static/media/icon_leftmenu_doctor04.2e679cff.svg";
export { ForwardRef as ReactComponent };